export const VIDEO_TIMESTAMP_CLASS = 'video-timestamp';

export const INLINE_COMMENT_LOOM_VIDEO_SELECTOR = 'a.external-link';
export const COMMENT_CONTAINER_CLASS = 'content-section';
export const COMMENT_CONTAINER_SELECTOR = `div.${COMMENT_CONTAINER_CLASS}`;
export const COMMENT_REPLY_CONTAINER_CLASS = 'reply-content-section';
export const COMMENT_REPLY_CONTAINER_SELECTOR = `div.${COMMENT_REPLY_CONTAINER_CLASS}`;
export const ADD_COMMENT_CONTENT_CONTAINER_CLASS = 'add-comment-content';
export const ADD_COMMENT_CONTENT_CONTAINER_SELECTOR = `div.${ADD_COMMENT_CONTENT_CONTAINER_CLASS}`;

export const INLINE_COMMENT_LOOM_VIDEO_RESIZE_DELAY = 1000;
